// extracted by mini-css-extract-plugin
module.exports = {"cookiebar":"styles-module--cookiebar--2Q-tU","alert":"styles-module--alert--bHbFU","closeBtn":"styles-module--close-btn--3HrJ-"};